import {
	some,
	map,
	flatten
} from "lodash";

function controller($element, $transclude, $userProfile) {
	this.$postLink = postLink;

	function postLink() {
		const user = $userProfile.getUser();
		const roles = user.roles || [];

		const hasRole = some(
			flatten(map(roles, role => this.roles.indexOf(role) !== -1)),
			Boolean
		);

		if(hasRole) {
			$element.append($transclude());
		}
	}
}

export default angular
	.module("vesl.components.require-role", [])
	.component("requireRole", {
		transclude: true,
		controller,
		bindings: {
			roles: "<"
		}
	}).name;
